"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnectingAttributes = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../../../../model");
/**
 * @internal
 */
function useConnectingAttributes(currentFilterDisplayForm, neighborFiltersDisplayForms) {
    var isDependentFiltersEnabled = model_1.useDashboardSelector(model_1.selectSupportsElementsQueryParentFiltering);
    var pairs = react_1.useMemo(function () {
        return neighborFiltersDisplayForms.map(function (neighborDisplayForm) { return [
            currentFilterDisplayForm,
            neighborDisplayForm,
        ]; });
    }, [neighborFiltersDisplayForms, currentFilterDisplayForm]);
    var _a = model_1.useDashboardQueryProcessing({
        queryCreator: model_1.queryConnectingAttributes,
    }), getConnectingAttributes = _a.run, connectingAttributes = _a.result, connectingAttributesStatus = _a.status, connectingAttributesError = _a.error;
    react_1.useEffect(function () {
        // if the backend does not support the parent attributes, we must not run the query, it will end in an error
        if (isDependentFiltersEnabled) {
            getConnectingAttributes(pairs);
        }
    }, [pairs, getConnectingAttributes, isDependentFiltersEnabled]);
    var connectingAttributesLoading = react_1.useMemo(function () {
        return connectingAttributesStatus === "pending" || connectingAttributesStatus === "running";
    }, [connectingAttributesStatus]);
    if (!isDependentFiltersEnabled) {
        // if the backend does not support the parent attributes, return en empty response
        return {
            connectingAttributes: [],
            connectingAttributesError: undefined,
            connectingAttributesLoading: false,
        };
    }
    return {
        connectingAttributes: connectingAttributes,
        connectingAttributesLoading: connectingAttributesLoading,
        connectingAttributesError: connectingAttributesError,
    };
}
exports.useConnectingAttributes = useConnectingAttributes;
//# sourceMappingURL=useConnectingAttributes.js.map